var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercises({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3711",
    "data-name": "Group 3711",
    transform: "translate(-406 -459)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(406 459)",
    fill: "#fcf4f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3710",
    "data-name": "Group 3710",
    transform: "translate(422 475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17200",
    "data-name": "Path 17200",
    d: "M44.226,20.064l-5.6-5.343V3.755a1.621,1.621,0,0,0-1.609-1.609H30.578a1.621,1.621,0,0,0-1.609,1.609v1.76L23.647.451a1.607,1.607,0,0,0-2.232,0L.88,20.021a2.674,2.674,0,0,0,1.8,4.656H6.438V38.089a4.835,4.835,0,0,0,4.828,4.828H21.5a4.164,4.164,0,0,1-.043-.73,7.987,7.987,0,0,1,2.36-5.686l1.245-1.245A8.072,8.072,0,0,1,33.3,33.3a7.821,7.821,0,0,1-.408-2.532,8,8,0,0,1,2.36-5.708L36.5,23.819a8.143,8.143,0,0,1,8.562-1.8v-.021A2.64,2.64,0,0,0,44.226,20.064Z",
    fill: "#f16238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17201",
    "data-name": "Path 17201",
    d: "M36.649,18.629,31.1,13.082a3.844,3.844,0,0,0-5.311,0L24.534,14.34a3.761,3.761,0,0,0,0,5.311l1.257,1.257-4.867,4.867-1.257-1.257a3.76,3.76,0,0,0-5.309,0L13.1,25.775a3.746,3.746,0,0,0,0,5.3l5.547,5.547a3.751,3.751,0,0,0,5.311,0l1.257-1.257a3.761,3.761,0,0,0,0-5.311L23.959,28.8l4.867-4.867,1.257,1.257a3.758,3.758,0,0,0,5.309,0l1.257-1.257a3.746,3.746,0,0,0,0-5.3Z",
    transform: "translate(13.75 13.77)",
    fill: "#ffac93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercises);
export default __webpack_public_path__ + "static/media/Exercises.38bbaba7fd6f6b88c52de6479dbd34f0.svg";
export { ForwardRef as ReactComponent };